import { Link } from "react-router-dom";

export default function ExploreCard({ className, data }) {
  return (
    <Link
      to={`/explore/${data?.id}`}
      onClick={() => window.scrollTo(0)}
      className={`w-full flex flex-col bg-transparent ${className}`}
    >
      <div className="w-full h-[220px] md:h-[380px] relative mb-[14px]">
        <div
          className="bgImage"
          style={{
            backgroundImage: `url(${process.env.REACT_APP_BASE_URL}/${
              data?.images && data?.images
            })`,
          }}
        />
      </div>
      <div className="flex flex-col">
        <div className="text-[12px] md:text-[20px] leading-4 md:leading-7 font-semibold text-[#263238]">
          {data?.title}
        </div>
        {data?.price && (
          <div className="text-[12px] md:text-[20px] leading-4 md:leading-7 font-semibold text-primary-700">
            RM{data?.price}
          </div>
        )}
      </div>
    </Link>
  );
}
